/**
 * newspaperOperationBtnsModule
 * description: 纸媒渠道下操作按钮
 * author: Qian.qianchen 2019-03-21
 */
'use strict';
angular.module('newspaperOperationBtnsModule', []).directive('newspaperOperationBtns', [
    'modalDialog',
    'trsHttpService',
    'editNewspaperService',
    '$q',
    'trsPrintService',
    'trsspliceString',
    function(modalDialog, trsHttpService, editNewspaperService, $q, trsPrintService, trsspliceString) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionPending/directive/newspaperOperationBtns/newspaperOperationBtns_tpl.html',
            scope: {
                selectedArr: '=',
                callback: '&',
            },
            link: function($scope, iElement, attrs) {

                /** * 纸媒操作 start ***/
                /**
                 * [shangbanForNewspaper description] 批量上版
                 * @return {[type]} [description]
                 */
                $scope.shangbanForNewspaper = function() {
                    var transferData = {
                        title: '上版',
                        opinionTit: '上版意见',
                        selectedArr: $scope.selectedArr,
                        isShowDate: true,
                        relatedManuMethod: 'queryRelateDocsInJinRi',
                        PaperId: $scope.selectedArr[0].SIDEID,
                        queryMethod: 'queryToDayDocs',
                        canDesignatedAuditor: true
                    };
                    editNewspaperService.changeLayoutDraft(
                        transferData,
                        function(result) {
                            var params = Object.assign({
                                serviceid: 'mlf_paper',
                                methodname: 'doShangBanJinRi',
                                PaperId: $scope.selectedArr[0].SIDEID,
                                SrcDocIds: result.srcdocids,
                                BanMianID: result.banmianid,
                                Option: result.option,
                                PubDate: result.dateStr,
                                SrcBanMianIds: result.SrcBanMianIds,
                            }, formatParams(result.selected));
                            $scope.$parent.$parent.loadingPromise = trsHttpService
                                .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                                .then(function(data) {
                                    modalDialog.alertType('上版成功', '', 'success', false, function() {
                                        $scope.callback();
                                    });
                                });
                        },
                        function() {
                            $scope.callback();
                        }
                    );
                };
                
                function formatParams(selected) {
                    var params = {};
                    params.verifyType = selected.selectedType;
                    switch (params.verifyType) {
                        case 0: 
                            params.userIds = trsspliceString.spliceString(selected.selectedArray, 'ID', ',');
                            break;
                        case 1:
                            params.userGroups = trsspliceString.spliceString(selected.selectedArray, 'GROUPID', ',');
                            break;
                    }
                    return params;
                }

                /**
                 * [rejectionForNewspaper description] 退稿
                 * @return {[type]} [description]
                 */
                $scope.rejectionForNewspaper = function() {
                    rejectionDraftofPage($scope.selectedArr);
                };

                /**
                 * [rejectionDraftofPage description]
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                function rejectionDraftofPage(item) {
                    var transferDate = {
                        items: item,
                        PaperDocIds: trsspliceString.spliceString(item, 'METADATAID', ','),
                    };
                    editNewspaperService.newspaperBackManuscript(
                        transferDate,
                        function(result) {
                            $scope.callback();
                        },
                        function() {}
                    );
                }

                /**
                 * [printBtnForNewsPaper description] 打印
                 * @return {[type]} [description]
                 */
                $scope.printBtnForNewsPaper = function() {
                    var chnlDocIdsArray = trsspliceString.spliceString($scope.selectedArr, 'METADATAID', ',');
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'queryViewDatas',
                        MetaDataIds: chnlDocIdsArray,
                    };

                    /**
                     * [requestVersion description] 查询版本
                     * @return  {[type]}  [return description]
                     */
                    function requestVersion() {
                        var idsArray = trsspliceString.getArrayString($scope.selectedArr, 'METADATAID', ',').split(',');
                        var versionResult = {};
                        var count = 0;
                        var defer = $q.defer();
                        angular.forEach(idsArray, function(value, key) {
                            trsHttpService
                                .httpServer(
                                    trsHttpService.getWCMRootUrl(),
                                    {
                                        serviceid: 'mlf_metadatalog',
                                        methodname: 'query',
                                        MetaDataId: value,
                                    },
                                    'get'
                                )
                                .then(function(data) {
                                    versionResult[value] = data.DATA;
                                    count++;
                                    if (count == idsArray.length) {
                                        defer.resolve(versionResult);
                                    }
                                });
                        });
                        return defer.promise;
                    }
                    $scope.$parent.$parent.loadingPromise = $q
                        .all([trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get'), requestVersion()])
                        .then(function(data) {
                            var detail = data[0];
                            var version = data[1];
                            for (var i = 0; i < detail.length; i++) {
                                detail[i].VERSION = version[detail[i].METADATAID];
                                if (i + 1 == detail.length) {
                                    trsPrintService.trsPrintDocument(detail);
                                }
                            }
                        });
                };

                /** * 纸媒操作 end ***/
            },
        };
    },
]);
